module.exports = __webpack_public_path__ + "public/Icons/mainSite.svg?1770b5e0";